import { useState } from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { MaskedText, Reveal, FadeIn } from "@/components/motion/Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
  const [hover, setHover] = useState(null);

  return (
    <>
      <section className="px-6 pb-16 pt-36 md:px-12 md:pt-48">
        <div className="mx-auto max-w-[1600px]">
          <FadeIn>
            <p className="overline mb-8 flex items-center gap-3 text-muted">
              <span className="h-px w-10 bg-clay" />
              Services — Index 03
            </p>
          </FadeIn>
          <MaskedText
            lines={["What I", "Offer"]}
            className="font-display text-[12vw] font-extralight leading-[0.9] tracking-tight text-ink md:text-[8vw]"
          />
        </div>
      </section>

      <div className="border-y border-hairline py-6">
        <Marquee speed={28} gradient={false} autoFill>
          <span className="mx-6 font-display text-xl font-light tracking-wide text-muted md:text-2xl">
            Motion — Concept — Image Making — Making — Collaboration —
          </span>
        </Marquee>
      </div>

      <section data-testid="services-list" className="px-6 py-8 md:px-12">
        <div className="mx-auto max-w-[1400px]">
          {SERVICES.map((service) => (
            <Reveal key={service.no}>
              <div
                data-testid={`service-${service.no}`}
                onMouseEnter={() => setHover(service.no)}
                onMouseLeave={() => setHover(null)}
                className="group grid grid-cols-12 items-start gap-4 border-b border-hairline py-10 transition-colors duration-500 md:py-14"
              >
                <span className="col-span-2 font-mono text-sm text-clay md:col-span-1">{service.no}</span>
                <h2 className="col-span-10 font-display text-2xl font-extralight leading-[1] tracking-tight text-ink transition-transform duration-500 group-hover:translate-x-2 md:col-span-6 md:text-4xl">
                  {service.title}
                </h2>
                <div className="col-span-12 mt-4 md:col-span-5 md:mt-0">
                  <p className="font-body text-sm leading-relaxed text-stone">{service.body}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {service.tags.map((tag) => (
                      <span key={tag} className="overline border border-hairline px-3 py-1.5 text-[0.6rem] text-stone">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="px-6 py-28 md:px-12 md:py-40">
        <div className="mx-auto max-w-[1400px] text-center">
          <Reveal>
            <p className="overline mb-8 text-muted">Have a project in mind?</p>
            <Link
              to="/contact"
              data-testid="services-contact-cta"
              className="group inline-flex items-center gap-4 font-display text-3xl font-extralight tracking-tight text-ink md:text-6xl"
            >
              Let’s talk
              <span className="text-clay transition-transform duration-500 group-hover:translate-x-3">↗</span>
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
